module.exports = __webpack_public_path__ + "img/sb09.92636030.png";